export default __webpack_public_path__ + "static/media/manzil-stack1.webp";